import { Navigation } from '@/features/navigation';
import { useProfileQuery } from '@/models/user';
import { FullPageProgress } from '@/components/FullPageProgress';
import { ExperimentsProvider } from '@/commons/tracking';
import { initAll, identify } from '@amplitude/unified';
import { Identify } from '@amplitude/analytics-browser';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

initAll(import.meta.env.VITE_AMPLITUDE_API_KEY);

const App = () => {
  const { data, isLoading } = useProfileQuery();
  const { i18n } = useTranslation();

  useEffect(() => {
    dayjs.locale(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    if (data?.id) {
      identify(new Identify().set('userType', 'premium'));
    }
  }, [data?.id]);

  if (isLoading) {
    return <FullPageProgress />;
  }

  if (!data?.id) {
    return <Navigation />;
  }

  return (
    <ExperimentsProvider
      apiKey={import.meta.env.VITE_AMPLITUDE_API_KEY}
      userId={data?.id?.toString()}
      userProperties={{
        email: data?.email,
      }}
    >
      <Navigation />
    </ExperimentsProvider>
  );
};

export default App;
